import base from "../../baseurl";
import token from "../../getTk";

const showAll = async () => {
  const tokenA = token.get();
  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });
  const Create = await api
    .post("discipline-types/showall", {
      json: {},
      timeout: false,
    })
    .json();
  console.log(Create);
  return Create;
};

export default showAll;
